import { ImgHelper } from '../../../helpers/ImgHelper'

export function AppFooterComponent() {

  const year = new Date().getFullYear().toString()

  return (
    <footer className="border-top footer text-muted">
      <div className="container">
        <div className="flex">
          <span>&copy; {year} - Powered by </span>
          <a href="https://www.auto-interleasing.ch/" title="Auto Interleasing AG" target="_blank" rel='noreferrer'>
            <img
              alt="InterfleetLink"
              className="logoAil"
              src="/interleasing-new-white.svg"
              width="183"
              height="56"
              data-fallback="/interleasing-new-white.png"
              onError={(e) => ImgHelper.handleImageLoadingFailure(e)}
            />
          </a>
        </div>
      </div>
    </footer>
  )
}